import { VET_ADVICE_CRISP_ID } from '@application/constants';
import { useRouter } from '@application/utils';
import { Analytics } from '@application/utils/analytics';
import { ThankyouPage } from '@presentation/pages';
import type { FC } from 'react';
import { useCallback, useEffect, useMemo } from 'react';

export const ThankyouPageController: FC = () => {
  const { infoFromCurrentPath, navigateToRoute } = useRouter();

  const shouldSendAnalyicsEvent = useMemo(() => {
    return (
      Object.hasOwn(infoFromCurrentPath.search, 'status') &&
      infoFromCurrentPath.search.status === 'success'
    );
  }, [infoFromCurrentPath.search]);

  const assistanceLink = `https://go.crisp.chat/chat/embed/?website_id=${VET_ADVICE_CRISP_ID}`;

  useEffect(() => {
    if (shouldSendAnalyicsEvent) {
      Analytics.sendVetAdviceSuccessThankyouPage();
      navigateToRoute('thankyou');
    }
  }, [navigateToRoute, shouldSendAnalyicsEvent]);

  const onWhatsAppClickHandler = useCallback(() => {
    window.open('https://wa.me/', '_blank');
  }, []);

  return <ThankyouPage assistanceLink={assistanceLink} onWhatsAppClick={onWhatsAppClickHandler} />;
};
